export const twitterIcon = "/assets/social-icons/twitter.svg";

export const instagramIcon = "/assets/social-icons/ig.svg";

export const facebookIcon = "/assets/social-icons/fb.svg";

export const youtubeIcon = "/assets/social-icons/yt.svg";

export const websiteIcon = "/assets/social-icons/website.svg";
